import { createWorkflow as postCreateWorkflow } from '~/api/workflows';

export const createWorkflow = async (workflow: unknown) => {
  return postCreateWorkflow(workflow);
};
